require('./bootstrap');

window.Vue = require('vue').default;
window.csrf = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

/*import Alpine from 'alpinejs';

window.Alpine = Alpine;
Alpine.start();*/
import 'vue-search-select/dist/VueSearchSelect.css'
import '@fortawesome/fontawesome-free/js/all.js';

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

import PerfectScrollbar from 'perfect-scrollbar';
import VueDragscroll from "vue-dragscroll";

window.PerfectScrollbar = PerfectScrollbar;

//require('dragscroll/dragscroll');
//import {dragscroll} from "vue-dragscroll";

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context('./', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('example-component', require('./components/ExampleComponent.vue').default);
Vue.use(VueSweetalert2);
Vue.use(VueDragscroll);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

if (document.getElementById('app') !== null) {
    const app = new Vue({
        el: '#app'/*,
    method: {
        updateTechAttribute(id, attribute, value){

        }
    }*/
    });
}

const catList = document.querySelectorAll('.catalog-cats-content[data-ps="1"]');
catList.forEach((elem) => {
    new PerfectScrollbar(elem);
})

const oformlenie = document.querySelectorAll('.oformlenie-elems');
oformlenie.forEach((elem) => {
    new PerfectScrollbar(elem);
})

document.querySelector('body').addEventListener('click', (e) => {

})

let formList = document.getElementsByTagName('form');
let dopInfo = document.getElementById('dop_info-tpl');
let geoInput = document.createElement('input');

geoInput.name = 'geo';
geoInput.type = 'hidden';

for (let i = 0; i < formList.length; i++) {
    formList[i].appendChild(dopInfo.cloneNode(true));
}


$(document).ready(function () {
    $("input[name='phone']")
        .on('input', function (e) {
            $(this).val($(this).val().replace(/[^0-9+()-]/g, ''));
        }).attr('maxlength', 18);

    $('a[href*="#"]:not([href="#"]):not(.fancybox)').click(function () {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
                document.getElementById(this.hash.slice(1)).scrollIntoView({behavior: 'smooth', block: 'start'})
                return false;
            }
        }
    });
    //$('select').select2();
})

const ofCanvasButtons = document.querySelectorAll('[data-toggle="offcanvas"]');
ofCanvasButtons.forEach((btn) => {
    btn.addEventListener('click', (e) => {
        let canvasId = btn.getAttribute('data-bs-target');
        let canvasElem = document.querySelector(canvasId);
        if (canvasElem) {
            let canvasObject = bootstrap.Offcanvas.getOrCreateInstance(canvasElem);

            canvasElem.addEventListener('hide.bs.offcanvas', function () {
                btn.classList.remove('--open');
                btn.querySelector('span').innerText = 'Подробнее';
            });

            canvasElem.addEventListener('hidden.bs.offcanvas', function () {
                const activeCanvas = document.querySelectorAll('.offcanvas.show');
                if (activeCanvas.length === 0)
                    document.querySelector('body').classList.remove('--offcanvas-open');
            });

            canvasElem.addEventListener('show.bs.offcanvas', function () {
                const canvasList = document.querySelectorAll('.offcanvas.offcanvas-sidebar');
                canvasList.forEach((canvas) => {
                    let _canvas = bootstrap.Offcanvas.getOrCreateInstance(canvas);
                    if (_canvas._isShown === true) {
                        _canvas.hide();
                    }
                });

                btn.classList.add('--open');
                btn.querySelector('span').innerText = 'Свернуть';
                document.querySelector('body').classList.add('--offcanvas-open');
            });

            canvasObject.toggle();
        }
    })
});

const xhrFormsSend = document.querySelectorAll('[data-xhr="true"]');
if (xhrFormsSend.length) {
    xhrFormsSend.forEach((form) => {
        form.addEventListener('submit', (e) => {
            e.preventDefault();

            let formIsModal = form.hasAttribute('data-modal-form');

            form.querySelector('[type="submit"]').setAttribute('disabled', 'disabled');
            let formData = new FormData(form);
            axios.post("/send-form", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }).then((res) => {
                form.querySelector('[type="submit"]').removeAttribute('disabled');

                if (res.data.status === 'error') {
                    alert('Возникла ошибка при отправке данных. Проверьте правильность ввода');
                    return false;
                }


                if (formIsModal) {
                    let parentElem = form.closest('.modal ');
                    if (parentElem) {
                        let modal = bootstrap.Modal.getOrCreateInstance(parentElem);
                        modal.hide();

                        let successModalElem = document.getElementById('successSend');
                        if (successModalElem) {
                            let successModal = bootstrap.Modal.getOrCreateInstance(successModalElem);
                            successModal.show();
                        }
                    }
                } else {
                    let successModalElem = document.getElementById('successSend');
                    if (successModalElem) {
                        let successModal = bootstrap.Modal.getOrCreateInstance(successModalElem);
                        successModal.show();
                    }
                }
            })
                .catch((err) => {
                    alert('Возникла ошибки...')
                });
        })
    })
}


/*
const openSpecs = document.querySelectorAll('[data-target="open-specs"]');
openSpecs.forEach((ob) => {
    ob.addEventListener('click', (e) => {
        let specId = ob.getAttribute('data-specs');
        let specList = document.querySelector(`[data-specs_list="${specId}"]`);
        if (specList) {
            if (ob.classList.contains('--active')) {
                ob.classList.remove('--active')
                specList.classList.remove('--active');
            } else {
                ob.classList.add('--active')
                specList.classList.add('--active');
            }
        }
    });
});
const openPriceParam = document.querySelectorAll('[data-target="open-price_param"]');
openPriceParam.forEach((op) => {
    op.addEventListener('click', (e) => {
        let priceId = op.getAttribute('data-price_param');
        let paramBlock = document.querySelector(`[data-price_param_block="${priceId}"]`);
        if (paramBlock) {
            if (op.classList.contains('--active')) {
                op.classList.remove('--active')
                paramBlock.classList.remove('--active');
            } else {
                op.classList.add('--active')
                paramBlock.classList.add('--active');
            }
        }
    });
});
*/

/*
function discountTimer(countDownDate){
    setInterval(function() {
        var now = new Date().getTime();
        var distance = countDownDate.getTime() - now;
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        document.querySelector('[class="countdown-timer"]').style.opacity = 1;

        /!* document.querySelector('[data-timer="days"]')
             .querySelector('[class="countdown-number"]').innerHTML = days;
         document.querySelector('[data-timer="days"]')
             .querySelector('[class="timer"]').style.strokeDashoffset = 224/days*-1*3;
     *!/
        document.querySelector('[data-timer="hours"]')
            .querySelector('[class="countdown-number"]').innerHTML = hours;
        document.querySelector('[data-timer="hours"]')
            .querySelector('[class="timer"]').style.strokeDashoffset = 224/24*-1*hours;

        document.querySelector('[data-timer="minute"]')
            .querySelector('[class="countdown-number"]').innerHTML = minutes;
        document.querySelector('[data-timer="minute"]')
            .querySelector('[class="timer"]').style.strokeDashoffset = 224/60*-1*minutes;

        document.querySelector('[data-timer="seconds"]')
            .querySelector('[class="countdown-number"]').innerHTML = seconds;
        document.querySelector('[data-timer="seconds"]')
            .querySelector('[class="timer"]').style.strokeDashoffset = 224/60*-1*seconds;

        if (distance < 0) {
            clearInterval(x);
            document.getElementById("demo").innerHTML = "EXPIRED";
        }
    }, 1000);
}*/
